export default {
    setHubNames(state, data) {
        state.hubNames = data;
    },

    setServices(state, data) {
        state.services = data;
    }
}
